module.exports = __webpack_public_path__ + "img/11-half-sm.7e3aeb9d.jpg";